import React, { useState, useEffect } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import axios from "axios";
import moment from "moment";

export default function OverTimeChart2() {
    const [data, setData] = useState([]);
    const userId = sessionStorage.getItem("userId");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchWeeklyData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await axios.get(`/user/performance-weekly-average/${userId}`);
                setData(response.data.data);
                console.log(response.data.data)
            } catch (error) {
                console.error("Error fetching weekly average data:", error);
                setError("Failed to fetch weekly average data");
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchWeeklyData();
        }
    }, [userId]);

    if (loading) return <div>Loading weekly average scores...</div>;
    if (error) return <div>Error loading weekly average scores: {error}</div>;

    const formatDate = (dateStr) => moment(dateStr).format('YYYY-MM-DD');

    return (
        <div className="chart-container">
            <ResponsiveContainer width="100%" height={400}>
                <BarChart
                    data={data}
                    margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                    <XAxis
                        dataKey="date"
                        angle={-45}
                        textAnchor="end"
                        height={60}
                        tickFormatter={formatDate}
                    />
                    <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} suffix="%" />
                    <Tooltip formatter={(value) => [`${value}%`, "Your average"]} labelFormatter={(label) => `Week of: ${formatDate(label)}`} />
                    <Legend verticalAlign="top" height={36} />
                    <Bar dataKey="yourAverage" fill="#1E88E5" name="Your average" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}